





















































































































































































import { FormModel } from "ant-design-vue";
import { UploadFile } from "ant-design-vue/types/upload";
import { Component, Ref, Vue } from "vue-property-decorator";

import SelectUploadDataFeature from "@/components/custom/select/SelectUploadDataFeature.vue";
import { debounceProcess } from "@/helpers/debounce";
import { APagination, useBlob, useTax, useUploadTaxIncome } from "@/hooks";
import MNotificationVue from "@/mixins/MNotification.vue";
import { Option } from "@/models/class/option.class";
import {
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
  PAGE_SIZE_OPTIONS,
} from "@/models/constant/global.constant";
import { Pagination } from "@/models/constant/interface/common.interface";
import { DATE_TIME_DEFAULT_FORMAT } from "@/models/constants/date.constant";
import { AccountingTaxResponseDto } from "@/models/interface/master-tax";
import {
  UploadTaxIncomeHistoryParams,
  UploadTaxIncomeHistoryResponseDto,
  UploadTaxIncomeStatus,
} from "@/models/interface/upload-tax-income/UploadTaxIncomeHistoryResponseDto.interface";
import { LabelInValue } from "@/types";

type Form = {
  pphType: LabelInValue | undefined;
};

@Component({
  mixins: [MNotificationVue],
  components: {
    SelectUploadDataFeature,
  },
})
export default class UploadTaxIncome extends Vue {
  fileList: UploadFile[] = [];

  @Ref("formModel")
  formModel!: FormModel;

  incomeTaxReceivableOptions: Option<AccountingTaxResponseDto>[] = [];

  dataHistoryUpload: Pagination<UploadTaxIncomeHistoryResponseDto> = {
    currentPage: 0,
    data: [],
    totalElements: 0,
    totalPages: 0,
  };

  PAGE_SIZE_OPTIONS = PAGE_SIZE_OPTIONS;
  dateTimeDefaultFormat = DATE_TIME_DEFAULT_FORMAT;

  filter = {
    pphType: undefined,
    status: undefined,
  };

  params: UploadTaxIncomeHistoryParams = {
    pphTypeId: undefined,
    status: undefined,
    page: DEFAULT_PAGE - 1,
    limit: DEFAULT_PAGE_SIZE,
  };

  pagination = {
    page: DEFAULT_PAGE - 1,
    limit: DEFAULT_PAGE_SIZE,
  };

  loading = {
    downloadTemplate: false,
    uploadData: false,
    historyUpload: false,
    taxIncomeTaxReceivable: false,
    process: false,
    downloadTaxIncome: false,
  };

  form: Form = {
    pphType: undefined,
  };

  formRules = {
    pphType: [
      {
        required: true,
        type: "object",
        message: this.$t("lbl_pph_type_required"),
      },
    ],
  };

  statusOptions: Option[] = [
    {
      key: UploadTaxIncomeStatus.FAILED,
      value: UploadTaxIncomeStatus.FAILED,
      label: this.$t("lbl_failed").toString(),
    },
    {
      key: UploadTaxIncomeStatus.PENDING,
      value: UploadTaxIncomeStatus.PENDING,
      label: this.$t("lbl_pending").toString(),
    },
    {
      key: UploadTaxIncomeStatus.SUCCESS,
      value: UploadTaxIncomeStatus.SUCCESS,
      label: this.$t("lbl_success").toString(),
    },
  ];

  columns = [
    {
      title: this.$t("lbl_pph_type"),
      dataIndex: "pphType",
      width: 250,
      scopedSlots: { customRender: "nullable" },
    },
    {
      title: this.$t("lbl_status"),
      dataIndex: "status",
      width: 250,
      scopedSlots: { customRender: "nullable" },
    },
    {
      title: this.$t("lbl_upload_date"),
      dataIndex: "uploadDate",
      width: 200,
      scopedSlots: { customRender: "uploadDate" },
    },
    {
      title: this.$t("lbl_upload_by"),
      dataIndex: "uploadBy",
      width: 200,
      scopedSlots: { customRender: "nullable" },
    },
    {
      title: this.$t("lbl_total_pph_amount"),
      dataIndex: "totalPphAmount",
      width: 200,
      scopedSlots: { customRender: "currency" },
    },
    {
      title: this.$t("lbl_action"),
      key: "operation",
      scopedSlots: { customRender: "operation" },
      align: "center",
    },
  ];

  mounted(): void {
    this.fetchIncomeTaxReceivable();
    this.getHistoryUpload();
  }

  debouncedSearchTaxIncomeTaxRecevable = debounceProcess((val?: string) => {
    this.onSearchTaxIncomeTaxRecevable(val);
  });

  async fetchIncomeTaxReceivable(search?: string) {
    const { findAllIncomeTaxReceivable, toOptions } = useTax();
    try {
      const response = await findAllIncomeTaxReceivable(search);
      const options = toOptions(response.data);

      this.incomeTaxReceivableOptions = options;

      return options;
    } catch {
      return [];
    }
  }

  async onSearchTaxIncomeTaxRecevable(val?: string) {
    try {
      this.loading.taxIncomeTaxReceivable = true;
      this.fetchIncomeTaxReceivable(val);
    } finally {
      this.loading.taxIncomeTaxReceivable = false;
    }
  }

  onChangePphType(value: LabelInValue): void {
    if (!value) {
      this.params.pphTypeId = undefined;

      this.getHistoryUpload();
      return;
    }

    this.params.pphTypeId = value.key;

    this.getHistoryUpload();
  }

  onChangeStatus(value: LabelInValue): void {
    if (!value) {
      this.params.status = undefined;

      this.getHistoryUpload();
      return;
    }

    this.params.status = value.key as UploadTaxIncomeStatus;

    this.getHistoryUpload();
  }

  onTableChange(pagination: APagination): void {
    const { current, pageSize } = pagination;

    this.pagination.page = current;

    this.pagination.page =
      pageSize !== this.pagination.limit ? DEFAULT_PAGE : current;
    this.pagination.limit = pageSize;

    this.params.page = current - 1;
    this.params.limit = pageSize;

    this.getHistoryUpload();
  }

  downloadTemplate(): void {
    const { downloadTemplate } = useUploadTaxIncome();
    const { toDownload } = useBlob();

    this.loading.downloadTemplate = true;
    downloadTemplate()
      .then(res => {
        toDownload(res, `template_upload_tax_income.xlsx`);
      })
      .finally(() => {
        this.loading.downloadTemplate = false;
      });
  }

  buildDto(file: UploadFile<any>): FormData {
    const formData = new FormData();

    formData.append("file", file as unknown as Blob);
    formData.append(
      "pphTypeId",
      this.form.pphType ? this.form.pphType?.key : ""
    );

    return formData;
  }

  uploadFile(): void {
    this.formModel.validate((valid: boolean) => {
      const file = this.fileList[0];

      if (!file) {
        this.showNotifError("lbl_file_required");
        return;
      }

      if (!valid) {
        this.showNotifWarning("notif_validation_error");
        return;
      }

      const MAX_SIZE = 5242880;
      if (file.size >= MAX_SIZE) {
        this.showNotifError("lbl_message_file_size_exceeded", {
          fileSize: 5,
        });
        return;
      }

      const { uploadData } = useUploadTaxIncome();

      this.loading.uploadData = true;

      uploadData(this.buildDto(file))
        .then(() => {
          this.showNotifSuccess("notif_upload_file_success", {
            filename: file.name,
          });
          this.handleRemove();
          this.getHistoryUpload();
        })
        .finally(() => {
          this.loading.uploadData = false;
        });
    });
  }

  handleProcessTaxIncome(id: string): void {
    const { processTaxIncome } = useUploadTaxIncome();

    this.loading.process = true;

    processTaxIncome(id)
      .then(() => {
        this.showNotifSuccess("notif_process_tax_income_success");
        this.getHistoryUpload();
      })
      .finally(() => {
        this.loading.process = false;
      });
  }

  handleDownloadTaxIncome(path: string): void {
    const { downloadTaxIncome } = useUploadTaxIncome();
    const { toDownload } = useBlob();

    this.loading.downloadTaxIncome = true;

    const sanitizePath = path.replace(/\+/g, "%20");

    downloadTaxIncome(sanitizePath)
      .then(res => {
        toDownload(res, path);
      })
      .finally(() => {
        this.loading.downloadTaxIncome = false;
      });
  }

  handleRemove(): void {
    this.fileList = [];
  }

  async getHistoryUpload(): Promise<void> {
    const { historyUpload } = useUploadTaxIncome();

    try {
      this.loading.historyUpload = true;
      const res = await historyUpload(this.params);

      this.dataHistoryUpload = res;
    } finally {
      this.loading.historyUpload = false;
    }
  }

  handleChange(info): void {
    if (info.file.status === "removed") {
      this.fileList = [];
    } else {
      this.fileList = [info.file];
    }
  }

  isShowProcess(row: UploadTaxIncomeHistoryResponseDto): boolean {
    return row.status === UploadTaxIncomeStatus.PENDING;
  }

  isShowDownloadFailed(row: UploadTaxIncomeHistoryResponseDto): boolean {
    return row.status === UploadTaxIncomeStatus.FAILED;
  }
}
